export default {
    INIT: 'INIT_BLOG',
    INITEDIT: 'INIT_EDIT_BLOG',
    SET: 'SET_EDIT_BLOG',
    SET_PAGINATION: '@__set_pagination_blog',
    SET_SINGLE_ITEM: 'SET_SINGLE_ITEM',
};
